import { HttpRequestError } from '../shared/request-error.js';
import {
  feedbackSubmissionSchema,
  type FeedbackSubmission,
} from '../shared/feedback.js';

const submissions = new Map<string, { id: string; expires: number; request?: Promise<void> }>();
const RETRY_WINDOW_MS = 10 * 60 * 1000;

export async function submitFeedback(
  payload: FeedbackSubmission,
  endpoint = '/api/feedback',
): Promise<void> {
  const parsed = feedbackSubmissionSchema.safeParse(payload);
  if (!parsed.success) throw new Error('Invalid feedback payload');

  const now = Date.now();
  for (const [key, submission] of submissions) {
    if (submission.expires <= now) submissions.delete(key);
  }
  // App details can change while the user retries the same message.
  const key = JSON.stringify([endpoint, parsed.data.message, parsed.data.email || '', parsed.data.page_path, parsed.data.context]);
  let submission = submissions.get(key);
  if (!submission) {
    submission = { id: crypto.randomUUID(), expires: now + RETRY_WINDOW_MS };
    submissions.set(key, submission);
  }
  if (!submission.request) {
    const current = submission;
    current.request = sendFeedback({ ...parsed.data, submission_id: current.id }, endpoint).catch(error => {
      current.request = undefined;
      throw error;
    });
  }
  await submission.request;
}

async function sendFeedback(payload: FeedbackSubmission, endpoint: string): Promise<void> {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new HttpRequestError(`Feedback request failed: ${response.status}`, response, 'feedback-client');
}
